// extracted by mini-css-extract-plugin
export default {"losSectionSmallDiv":"LosSectionSmall_losSectionSmallDiv__3jB+G"};